export default __webpack_public_path__ + "static/media/howTOaddItemsToCart.ed7dff57.png";